import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { DialogContent, DialogContentText } from "@material-ui/core";
import LegalEntityAddForm from "../LegalEntity/Add/LegalEntityAddForm";

const LegalEntityAddModal = (props) => {
  const { handleClose } = props;

  return (
    <Wrapper>
      <DialogContent>
        <DialogContentText>
          <LegalEntityAddForm isModal={true} handleClose={handleClose} />
        </DialogContentText>
      </DialogContent>
    </Wrapper>
  );
};

export default LegalEntityAddModal;
